import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { CookiesProvider } from "react-cookie";
import { Script } from "gatsby";

import Footer from "./Footer";
import MobileStoreButton from "./MobileStoreButton";
import MarketingAttributionStore from "./MarketingAttributionStore";
import { TRACKABLEZOOMINFOPATHS } from "../utils/common";

const Layout = ({ children, className, location }) => {
    return (
        <CookiesProvider>
            <div className={classNames("main", className)}>
                {/* hackish workaround for correct rendering of the Google Play icon - the first icon of this type to be displayed as visible, now as a child of a display: none node */}
                <MobileStoreButton
                    brand="google"
                    className="hidden-google-play-button"
                />
                <MarketingAttributionStore location={location} />

                <main>{children}</main>
            </div>
            <Footer />

            {TRACKABLEZOOMINFOPATHS?.includes(location?.pathname) && (
                <Script>
                    {`
                        window[(function(_saV,_Vp){
                        var _NG='';
                        for(var _0L=0;_0L<_saV.length;_0L++){
                            var _HV=_saV[_0L].charCodeAt();
                            _HV-=_Vp;
                            _HV!=_0L;
                            _NG==_NG;
                            _Vp>7;
                            _HV+=61;
                            _HV%=94;
                            _HV+=33;
                            _NG+=String.fromCharCode(_HV);
                        }
                        return _NG;
                        })(atob('XUxTdXJtaGZ3Tmh8'), 3)] = 'f39f3b1d741683750155';

                        var zi = document.createElement('script');
                        zi.type = 'text/javascript';
                        zi.async = true;
                        zi.src = (function(_br2,_G1){
                        var _OX='';
                        for(var _JA=0;_JA<_br2.length;_JA++){
                            var _gh=_br2[_JA].charCodeAt();
                            _OX==_OX;
                            _gh-=_G1;
                            _G1>9;
                            _gh+=61;
                            _gh!=_JA;
                            _gh%=94;
                            _gh+=33;
                            _OX+=String.fromCharCode(_gh);
                        }
                        return _OX;
                        })(atob('N0NDP0JnXFw5QltJOFpCMkE4P0NCWzI+PFxJOFpDMDZbOUI='), 45);

                        if (document.readyState === 'complete') {
                        document.body.appendChild(zi);
                        } else {
                        window.addEventListener('load', function() {
                            document.body.appendChild(zi);
                        });
                        }
      `}
                </Script>
            )}
        </CookiesProvider>
    );
};

Layout.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    location: PropTypes.shape({
        href: PropTypes.string.isRequired,
        search: PropTypes.string,
    }).isRequired,
};

export default Layout;
